import { useState } from "react";
import IOrganism from "./interface";
import {
  Card,
  Grid,
  Typography,
  Box,
  FormLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { Trans } from "@lingui/macro";
import CreateIcon from "@mui/icons-material/Create";
import JobCreateFormOrganism from "@organisms/JobCreate";
import NotesOrganism from "@organisms/Notes";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";

const JobDetailsFormOrganism = ({ job, onSave }: IOrganism) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const editMode = () => {
    setIsEditMode(isEditMode ? false : true);
  };

  const formSubmitted = () => {
    editMode();
    if (onSave) {
      onSave();
    }
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item md={7}>
          <Card sx={{ p: 1 }} className="ov-visible">
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box mr={1}>
                <Typography variant="h5">
                  <Trans>Job info</Trans>
                </Typography>
              </Box>
              <Box>
                {!isEditMode ? (
                  <IconButton onClick={editMode}>
                    <CreateIcon />
                  </IconButton>
                ) : (
                  <IconButton onClick={editMode}>
                    <CloseIcon />
                  </IconButton>
                )}
              </Box>
            </Box>
            {!isEditMode && (
              <Box>
                <Box mt={2}>
                  <Grid container>
                    <Grid item md={3}>
                      <FormLabel>
                        <b>
                          <Trans>Client</Trans>
                        </b>
                      </FormLabel>
                      <Box>{job.client.name}</Box>
                    </Grid>
                    <Grid item md={3}>
                      <FormLabel>
                        <b>
                          <Trans>Division - Service</Trans>
                        </b>
                      </FormLabel>
                      <Box>{`${job.type.name} - ${job.category.name}`}</Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box mt={2}>
                  <Grid container>
                    <Grid item md={3}>
                      <FormLabel>
                        <b>
                          <Trans>Project name</Trans>
                        </b>
                        <Box>{job.label ?? "--"}</Box>
                      </FormLabel>
                    </Grid>
                    <Grid item md={3}>
                      <FormLabel>
                        <b>
                          <Trans>Code ID</Trans>
                        </b>
                        <Box>{job.code_id ?? "--"}</Box>
                      </FormLabel>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}
            {isEditMode && (
              <Box mt={1}>
                <Grid container spacing={1}>
                  <Grid item md={12}>
                    <JobCreateFormOrganism
                      saveOnDestroy={true}
                      onCancel={() => setIsEditMode(false)}
                      job={job}
                      onSave={formSubmitted}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
          </Card>
        </Grid>
        <Grid item md={5}>
          <Accordion defaultExpanded={true} elevation={1}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
            >
              <span>
                <Typography variant="h5">
                  <b>
                    <Trans>Notes</Trans>
                  </b>
                </Typography>
              </span>
            </AccordionSummary>
            <AccordionDetails>
              <NotesOrganism
                model_id={job.id}
                model_type={"jobs"}
              ></NotesOrganism>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </>
  );
};

export default JobDetailsFormOrganism;
